import { ManagerModel } from "../../../api/models";
import { ModelId } from "../../../defines";

export interface EditingTargetData {
  id?: ModelId;
}

export enum ManagerProfileEditingSection {
  Overview = "overview",
  Video = "video",
  Details = "details",
  Team = "team",
  Opportunities = "opportunities",
  BasicInfo = "basicInfo",
  PhotoGallery = "photoGallery",
  TrackRecord = "trackRecord",
  Logo = "logo",
  BannerImages = "BannerImages",
}

export interface ManagerProfileState {
  manager: ManagerModel;
  isEditing: boolean;
  setEditingDrawer: (section: ManagerProfileEditingSection | null) => void;
  setEditingTargetData: (data: EditingTargetData) => void;
  editingDrawer: ManagerProfileEditingSection | null;
  editingTargetData: EditingTargetData | null;
  isEditor?: boolean;
  isPublic?: boolean;

  buildManagerProfileRouteUrl: (
    urlParams: Record<string, string | null | undefined>,
  ) => string;
}

export interface ManagerProfileProviderProps {
  manager: ManagerModel;
  isEditor?: boolean;
}
